import { withAdpCombine } from '../../config/context/config';
import { Pagination as AntdPagination } from './components/PaginationImpl';
export var Pagination = withAdpCombine(AntdPagination);